import React from "react";
import date from "./img/date.png";
import security from "./img/security.png";
import version from "./img/version.png";
import "./banner.scss";

const AppVersion = require("../../../package.json").version;

const LoginBanner = () => {
  return (
    <div className="banner-snjob-wrapper">
      <div className="banner-snjob">
        <div className="parent">
          <div className="child">
            <p className="text">SNJOB Club</p>
          </div>
          <div className="child">
            <div className="inner-child border-left">
              <img className="img" alt="سامانه سنجاب" src={security} />
              <p className="text">پلتفـرم امـن سـازی شـده</p>
            </div>
            <div className="inner-child">
              <img className="img" alt="نسخه سامانه سنجاب" src={version} />
              <p className="text">نسخـه {AppVersion}</p>
            </div>
            <div className="inner-child border-right">
              <img className="img" alt="اعتباربخشی سنجاب" src={date} />
              <p className="text">انتشـار اسفنـد مـاه 1402</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginBanner;
